import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { UtilService } from '@app/service/util.service';
import { Globals } from '@app/service/globals.service';

import { StatisticsService } from '@home/service/statistics.service';

import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';

import { AgGridHtmlComponent } from '@app/components/ag-grid-html/ag-grid-html.component';

@Component({
  selector: 'app-statistics-pg4',
  templateUrl: './statistics-pg4.component.html',
  styleUrls: ['./statistics-pg4.component.scss']
})
export class StatisticsPg4Component implements OnInit {

  search: any = {
    nowYear: '',
    pastYear: '',
    prodNm: ''
  };

  // 그리드 관련 선언
  selectedRows = 0;
  yearList: any = [];
  prodList: any = [];
  dataList: any = [];

  gridApiProd: any;
  gridColumnApiProd: any;
  columnDefsProd: any;
  defaultColDefProd: any;
  rowSelectionProd: any;

  gridApi: any;
  gridColumnApi: any;
  columnDefs: any;
  defaultColDef: any;
  rowSelection: any;

  noRowsTemplate: string;

  // 그리드 이미지 처리
  frameworkComponents = {
    agGridHtmlComponent: AgGridHtmlComponent
  };

  constructor(
    private utilService: UtilService,
    private toastrService: ToastrService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private globals: Globals,
    private statisticsService: StatisticsService
  ) {
    // ag grid 컬럼 선언
    this.columnDefsProd = [
      { headerName: '품목명', field: 'prod_nm', cellClass: 'cp', width: 280 }
    ];

    // ag grid 컬럼 선언
    this.columnDefs = [
      { headerName: '년도', field: 'exp_year', cellClass: 'cp center', width: 150 },
      { headerName: '수입수량', field: 'imp_qty', cellClass: 'cp right', width: 280,
        valueFormatter: currencyFormatter,
        valueGetter: function(params) {
          if( params.data.imp_qty !== null ) return params.data.imp_qty;
          else return 0;
        }
      },
      { headerName: '수입금액', field: 'imp_price', cellClass: 'cp right', width: 280,
        valueFormatter: currencyFormatter,
        valueGetter: function(params) {
          if( params.data.imp_price !== null ) return params.data.imp_price;
          else return 0;
        }
      },
      { headerName: '수출수량', field: 'exp_qty', cellClass: 'cp right', width: 280,
        valueFormatter: currencyFormatter,
        valueGetter: function(params) {
          if( params.data.exp_qty !== null ) return params.data.exp_qty;
          else return 0;
        }
      },
      { headerName: '수출금액', field: 'exp_price', cellClass: 'cp right', width: 280,
        valueFormatter: currencyFormatter,
        valueGetter: function(params) {
          if( params.data.exp_price !== null ) return params.data.exp_price;
          else return 0;
        }
      }
    ];

    // default 컬럼 옵션
    this.defaultColDefProd = {
      sortable: true,
      filter: false,
      resizable: true
    };

    // default 컬럼 옵션
    this.defaultColDef = {
      sortable: true,
      filter: false,
      resizable: true
    };

    this.rowSelectionProd = 'single';
    this.rowSelection = 'single';

    // 메시지 표시 선언
    this.noRowsTemplate = '검색된 데이터가 없습니다.';

    function currencyFormatter(params: any) {
      return Math.floor(params.value).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }
  }

  /*******************************************************************************
    설  명 : 데이터 초기화
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  async ngOnInit() {
    const startYear: any = 1990;
    const endYear: any = moment().add(2, 'years').format('YYYY');

    for (let year = startYear; year <= endYear; year++) {
      this.yearList.push({
        title: year + '년',
        value: year
      });
    }

    // 최근 년도 가져오기
    await this.getProdTotalLastYear();

    // 제품 리스트 가져오기
    await this.getImpExpProdList();
  }

  /*******************************************************************************
    설  명 : 뷰 처리 완료 후
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  ngAfterViewInit() {

    // indicator 표시
    /*
    setTimeout (() => {
      if ( this.dataList.length < 1 ) {
        this.globals.indicator.next(true);
      }
    });
    */
  }

  /*******************************************************************************
    설  명 : 최근 년도 가져오기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  async getProdTotalLastYear() {
    await this.statisticsService.getProdTotalLastYear( 'INOUT' ).then( response => {
      //console.log(response);
      if ( response.ResultCode ) {
        this.search.nowYear = response.data;
      } else {
        this.toastrService.error( response.ResultMessage, '' );
      }
    });
  }

  /*******************************************************************************
    설  명 : 제품 리스트 가져오기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  async getImpExpProdList() {
    this.search.pastYear = parseInt(this.search.nowYear) - 1;

    await this.statisticsService.getImpExpProdList( 'MONTH' ).then( response => {
      //console.log(response);
      if ( response.ResultCode ) {
        this.prodList = response.data;

        if ( this.search.prodNm === '' ) {
          this.search.prodNm = this.prodList[0].prod_nm;
        }

        this.getMonthImpExpList();
      } else {
        this.toastrService.error( response.ResultMessage, '' );
      }
    });
  }

  /*******************************************************************************
    설  명 : 월별 수출입통계 리스트 가져오기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  async getMonthImpExpList() {
    if ( this.dataList.length < 1 ) {
      this.globals.indicator.next(true);
    }

    await this.statisticsService.getMonthImpExpList( this.search ).then( response => {
      //console.log(response);
      if ( response.ResultCode ) {
        this.dataList = response.data;

        const node = this.gridApiProd.getSelectedNodes();

        if( node.length < 1 ) {
          let index = 0;
          this.gridApiProd.forEachNode(function(node) {
            if (index++ == 0 ) {
              node.setSelected(true);
            }
          });
        }

      } else {
        this.toastrService.error( response.ResultMessage, '' );
      }

      this.globals.indicator.next(false);
    });
  }

  /*******************************************************************************
    설  명 : ag grid ready 시 처리
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  onGridReadyProd(params) {
    this.gridApiProd = params.api;
    this.gridColumnApiProd = params.columnApi;
  }

  /*******************************************************************************
    설  명 : ag grid ready 시 처리
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  /*******************************************************************************
    설  명 : ag grid 행 클릭 시 처리 - 거래처 정보 수정
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  onRowClicked($event: any) {
    this.search.prodNm = $event.data.prod_nm;

    this.getMonthImpExpList();
  }
}
